module.exports = __webpack_public_path__ + "static/media/weight Loss.0f13ad6d.svg";